// import StringMask from 'string-mask'
import tokens from '../../assets/js/core/tokens'
import maskit from '../../assets/js/core/maskit'
import dynamicMask from '../../assets/js/core/dynamic-mask'

export const textFilters = {
    data () {
        return {
            formatMasks: {
                'standard': {name: 'Standard', format: null},
                'standardcaps': {name: 'Standard (Caps Only)', format: this.standardCapsOnly},
                'titlecase': {name: 'Title Case (Caps first letter of each word and lowercase the rest)', format: this.titleCase},
                'opentitlecase': {name: 'Open Title Case (Caps first letter of each word but otherwise makes no modifications)', format: this.openTitleCase},
                'letnum': {name: 'Letters & Numbers Only', format: this.letterNumbersOnly},
                'letnumcaps': {name: 'Letters & Numbers Only (Caps)', format: this.letterNumbersCapsOnly},
                'telephone1': {name: 'Telephone: X-XXX-XXX-XXXX', format: ['###-#####', '###-###-#####', '#-###-###-####']},
                'telephone2': {name: 'Telephone: X.XXX.XXX.XXXX', format: ['###.#####', '###.###.#####', '#.###.###.####']},
                'telephone3': {name: 'Telephone: (XXX) XXX-XXXX', format: ['###-#####', '(###) ###-#####', '# (###) ###-####']},
                'date1': {name: 'Date: XX/XX/XXXX', format: ['##/##/####']},
                'date2': {name: 'Date: XX.XX.XXXX', format: ['##.##.####']},
                'date3': {name: 'Date: XX-XX-XXXX', format: ['##-##-####']},
                'twitter': {name: 'Twitter: @xxxxxxxxxx', format: ['@XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX']}
            }
        }
    },
    methods: {
        fetchTextMask (id) {
            // JSON.parse used to strip the vue observer
            return JSON.parse(JSON.stringify(this.formatMasks[id].format))
        },
        textFormat (mask, text) {
            let maskString = this.formatMasks[mask].format
            if (maskString === null) {
                return text
            } else if (this.isFunction(maskString)) {
                return maskString(text)
            } else {
                return this.mask(text, maskString)
            }
        },
        mask (value, mask, masked = true) {
            return Array.isArray(mask)
                ? dynamicMask(maskit, mask, tokens)(value, mask, masked, tokens)
                : maskit(value, mask, masked, tokens)
        },
        isFunction (functionToCheck) {
            return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]'
        },
        standardCapsOnly (text) {
            return text.toUpperCase()
        },
        titleCase (text) {
            return text.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
            })
        },
        openTitleCase (text) {
            return text.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1)
            })
        },
        letterNumbersOnly (text) {
            return text.replace(/[^a-z0-9]/gi, '')
        },
        letterNumbersCapsOnly (text) {
            return text.replace(/[^a-z0-9]/gi, '').toUpperCase()
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/mixins/textFilters.js